import {
    Grid,
    Typography
} from '@mui/material';

const AboutForm = () => {
    return (
        <Grid container>
            <Grid item md={12} sm={12} xs={12}>
                <Typography component={'div'} className='set-parent-settings d-flex-ja'>
                    <Typography component={'div'} className='set-child'>
                        <Typography className='p-title sett-box d-flex-a px-24'>About</Typography>
                        <Typography component={'div'} className='company-text'>
                            People Optimizaton Index
                        </Typography>
                        <Typography component={'div'} className='px-24'>
                            A Product of The Encompass Group
                        </Typography>
                        <Typography component={'div'} className='px-24'>
                            All Rights Reserved
                        </Typography>
                        <Typography component={'div'} className='box-bottom'>
                            &copy; The Encompasss Group (2026)
                        </Typography>
                    </Typography>
                </Typography>
            </Grid>
        </Grid>
    )
}

export default AboutForm;